import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let ieMessage = 'N';
addEventListener('setParamsVitalSignValidator', (e) => {
    const ce = e;
    ieMessage = ce.detail.ieMessage;
});
export const VITAL_SIGN_VALIDATOR_VALUE_OF_RANGE = 'vital-sign-value-out-of-range';
async function vitalSignValidator(value) {
    let message = '';
    let valid = true;
    if (ieMessage && value) {
        message = ieMessage != 'N' ? MessageService.translate('message.value-out-of-reference') : '';
        valid = ieMessage === 'N';
    }
    const event = new CustomEvent('applyVitalSignValidation');
    dispatchEvent(event);
    return [{
            message: message,
            name: VITAL_SIGN_VALIDATOR_VALUE_OF_RANGE,
            valid: valid
        }];
}
export default vitalSignValidator;
//# sourceMappingURL=vital-sign-validator.js.map